'use strict';

export default function guideSlugFilter(slug) {
  'ngInject';

  const slugFilter = slug;

  return (guide = {}) => {
    let slug = [];

    if (guide.nameSlug) {
      slug.push(slugFilter.it(guide.nameSlug));
    } else if (guide.name) {
      slug.push(slugFilter.it(guide.name));
    }

    if (guide.location && guide.location.city && guide.location.country) {
      slug.push(slugFilter.it(guide.location.city));
      slug.push(slugFilter.it(guide.location.country));
    }

    if (guide.id) {
      slug.push(guide.id);
    } else if (guide.userId) {
      slug.push(guide.userId);
    }

    return slug
      .join('-');
  };
}



// WEBPACK FOOTER //
// ./app/src/filters/guide_slug.filter.js